import React, { isValidElement, useState } from 'react';

/**
 * WordPress Dependencies
 */
import { __ } from '@wordpress/i18n';
import { blockDefault } from '@wordpress/icons';
import { get, groupBy, isFunction } from 'lodash';
import { BlockIcon } from '@wordpress/block-editor';
import {
	SearchControl,
	MenuItem,
	MenuGroup,
	BaseControl,
} from '@wordpress/components';

/**
 * Custom Dependencies
 */
import { SUPPORTED_BLOCKS } from '../constants';

/**
 * A custom controls that allows search through the existing
 * block types.
 */
function BlockTypeSearch(props) {
	const [search, setSearch] = useState('');

	const filteredBlockTypes = SUPPORTED_BLOCKS().filter((blockType) => {
		const isBlockSearched =
			blockType.label.toLowerCase().indexOf(search.toLowerCase()) !== -1;

		const isQualified = search === '' ? true : isBlockSearched;
		return isQualified;
	});

	const groupedBlockTypes = groupBy(filteredBlockTypes, 'namespace');

	const hasBlocks = filteredBlockTypes.length > 0;

	return (
		<div className="abi-block-type-search-control">
			<BaseControl label={__('Block Type', 'automatic-block-inserter')}>
				<SearchControl
					value={search}
					onChange={setSearch}
					placeholder={__(
						'Search Block Type',
						'automatic-block-inserter'
					)}
				/>
			</BaseControl>
			{hasBlocks ? (
				<div className="abi-block-type-search-control-blocks">
					{Object.keys(groupedBlockTypes).map((group, groupIndex) => {
						const blockTypes = groupedBlockTypes[group];

						return (
							<MenuGroup label={group} key={groupIndex}>
								{blockTypes.map((blockType, index) => {
									const isSelected =
										blockType.value === props.value;

									const icon = get(
										blockType.icon,
										'src',
										null
									);

									const hasIcon =
										isFunction(icon) ||
										isValidElement(icon);

									return (
										<MenuItem
											key={index}
											iconPosition="left"
											isPressed={isSelected}
											icon={
												hasIcon ? (
													<BlockIcon icon={icon} />
												) : (
													blockDefault
												)
											}
											onClick={() =>
												props.onChange(blockType.value)
											}
										>
											{blockType.rawLabel}
										</MenuItem>
									);
								})}
							</MenuGroup>
						);
					})}
				</div>
			) : (
				<div className="abi-block-type-search-control-no-result">
					<p>{__('No blocks found.', 'automatic-block-inserter')}</p>
				</div>
			)}
		</div>
	);
}

export default BlockTypeSearch;
